import React from "react";
import AutocompleteMUI from "@material-ui/lab/Autocomplete";
import makeStyles from "@material-ui/styles/makeStyles";
import ClassNames from "classnames";

const useStyles = makeStyles(theme => ({
  autocomplete: {
    "& .MuiAutocomplete-inputRoot": {
      "& .MuiAutocomplete-input": {
        padding: "5.5px 4px",
      },
    },
  },
}));

function Autocomplete(props) {
  const classes = useStyles(props);
  return (
    <AutocompleteMUI
      className={ClassNames(props.className, classes.autocomplete)}
      {...props}
    />
  );
}

export default Autocomplete;
